export default __webpack_public_path__ + "static/media/Slide2.009a17a6.jpeg";